import * as _ from 'lodash';
import { evolve } from '../utility/evolve';

const stubSamlConfig = () => ({
  organization_id: '',
  issuer: '',
  host_fingerprint: '',
  allowable_clock_drift_min: 5,
  dob_format: '%Y-%m-%d',
  use_organization: false,
  vendor_settings: [stubVendorSetting()],
  certificates: [stubCertificate()]
});

const stubCertificate = () => ({
  sha1_fingerprint: '',
  public_certificate_pem: '',
  expiry_dt: '',
  description: ''
});

const stubVendorSetting = () => ({
  setting_type_code: 'SAMLTYPE_ATTRIBUTE',
  setting_name_code: 'SAMLNAME_DOB',
  setting_value: '',
  source_attribute_name: '',
  source_attribute_value: ''
});

const convertVendorSetting = settings => _.mapValues(settings, v => _.isNull(v) ? '' : v);

const convertToEditable = _.flow(
  evolve({
    vendor_settings: _.flow(
      settings => _.sortBy(settings, 'id'),
      settings => _.map(settings, _.flow(
        convertVendorSetting,
        v => _.defaultsDeep(v, stubVendorSetting())
      ))
    )
  }),
  v => _.defaultsDeep(v, stubSamlConfig())
);

const trimValues = config => _.mapValues(config, c => _.isObject(c) ? c : _.trim(c))

const fieldValueIsEmpty = v => _.isNull(v) || _.isUndefined(v) || v === '';
const vendorSettingIsEmtpy = settings =>
  fieldValueIsEmpty(settings.setting_value)
  && fieldValueIsEmpty(settings.source_attribute_name)
  && fieldValueIsEmpty(settings.source_attribute_value);
const certIsEmpty = cert => _.every(_.values(cert), fieldValueIsEmpty);

const convertToDb = _.flow(
  // trim whitespaces and remove empty fields
  samlConfig => trimValues(samlConfig),
  samlConfig => _.omitBy(samlConfig, fieldValueIsEmpty),
  evolve({
    vendor_settings: _.flow(
      settings => _.map(settings, _.flow(
        // remove extra keys and empty values
        setting => _.omit(setting, ['errors', 'isNew']),
        setting => trimValues(setting),
        setting => _.omitBy(setting, fieldValueIsEmpty),
      )),
      settings => _.reject(settings, vendorSettingIsEmtpy),
    ),
    certificates: _.flow(
      certs => _.map(certs, _.flow(
        cert => _.omit(cert, ['errors', 'isNew']),
        cert => trimValues(cert),
        cert => _.omitBy(cert, fieldValueIsEmpty)
      )),
      certs => _.reject(certs, certIsEmpty)
    )
  })
);

export {
  convertToEditable,
  convertToDb,
  stubVendorSetting,
  stubCertificate
};
